export default __webpack_public_path__ + "static/media/tropics.587b33310372e62153fe102132b7a8fa.jpg";